import React, {Component} from 'react'
import PropTypes from 'prop-types';
import { Segment, Icon, Label, Grid } from 'semantic-ui-react';
import { ACCOUNT_APP_VEHICLES, accountAppUrl } from '../../../modules/accountApp';

const noBorderStyle ={ 'borderStyle': 'none' };

const removeVehicleLinkStyle = {
    'backgroundColor': 'white'
};

const vrmStyle = { 'color': 'black' }

// Links to the list, not /vehicles/{id}: these ids come from parking-sessions and
// the account app's are its own, so a deep link 404s.
const RemoveVehicleLink = () => (
    <a href={accountAppUrl(ACCOUNT_APP_VEHICLES)} title='Remove this vehicle'>
        <Icon style={removeVehicleLinkStyle} color='red' name='cancel' circular link/>
    </a>
);

const VehicleLink = (props) => {
    const { vrm } = props;
    return ([
        <Segment key={0}style={noBorderStyle} secondary inverted attached color='blue' textAlign='center'>
                <Icon size='huge' name='car'/>
        </Segment>,
        <Segment key={1} style={noBorderStyle} inverted attached color='blue' attached='bottom' textAlign='left'>
            <Grid columns={2} verticalAlign='middle'>
                <Grid.Column width={10} textAlign='left'><Label color='yellow' size='large'><span style={vrmStyle}>{vrm}</span></Label></Grid.Column>
                <Grid.Column width={6} textAlign='right'><RemoveVehicleLink/></Grid.Column>
            </Grid>
        </Segment>
    ]);
};

VehicleLink.propTypes = {
  id: PropTypes.string.isRequired,
  vrm: PropTypes.string.isRequired
};

export default VehicleLink
